import { useCallback } from 'react'

import { loadHostMeetingPrepRemote } from './loadHostMeetingPrepRemote'

export const useOpenMeetingPrepFromHost = () => (
  useCallback(async (contact, meeting) => {
    try {
      const mod = await loadHostMeetingPrepRemote()
      mod?.openMeetingPrepFromHost?.(contact, meeting)
    } catch {
      // Remote missing/outdated - intentionally no-op.
    }
  }, [])
)
